$(() => {
    // Only load for specific rebates blocks
    if ($('.block.rebates, .block.related-rebates').length) {

        // Capture clicks
        $('body').on('click', function(e) {

            // Clicking on a share button
            var button = $(e.target).closest('div.share');
            if (button.length) {
                if (button.hasClass('active')) {
                    button.removeClass('active');
                }
                else {
                    // Close other open popups when opening a new one
                    $('.rebate .header div.share').removeClass('active');
                    button.addClass('active');
                }
            }

            // Clicking off somewhere else
            else {
                // Close all instances of open share popups
                if ($('.rebate .header div.share').hasClass('active')) {
                    $('.rebate .header div.share').removeClass('active');
                }
            }
        });
    }
})